import { Moon, Sun, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/components/theme-provider';
import { memo } from 'react';

// memo로 컴포넌트를 감싸서 불필요한 리렌더링 방지
export const ThemeToggle = memo(function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  // 테마 변경 핸들러를 별도 함수로 분리하여 매 렌더링마다 새 함수가 생성되는 것 방지
  const handleThemeChange = (newTheme: 'light' | 'dark' | 'system') => {
    setTheme(newTheme);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <span className="sr-only">테마 변경</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[8rem] rounded-lg p-2 border shadow-lg">
        <DropdownMenuItem 
          onClick={() => handleThemeChange('light')}
          className={`flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm ${theme === 'light' ? 'bg-primary/10 text-primary' : ''}`}
        >
          <Sun className="h-4 w-4" />
          <span>라이트</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleThemeChange('dark')}
          className={`flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm ${theme === 'dark' ? 'bg-primary/10 text-primary' : ''}`}
        >
          <Moon className="h-4 w-4" />
          <span>다크</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleThemeChange('system')}
          className={`flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm ${theme === 'system' ? 'bg-primary/10 text-primary' : ''}`}
        >
          <Monitor className="h-4 w-4" />
          <span>시스템</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});